var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-reservation-select" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.branches.length > 1,
            expression: "branches.length > 1",
          },
        ],
        staticClass:
          "c-reservation-select__holder js-reservation-select-holder",
      },
      [
        _c("input", {
          attrs: { name: "branch_id", type: "hidden" },
          domProps: { value: _vm.selectedBranchId },
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "c-reservation-select__button",
            attrs: { type: "button", disabled: !_vm.isInitialized },
            on: { click: _vm.onSelectClick },
          },
          [
            _c("span", { staticClass: "sc-text" }, [
              _vm._v(_vm._s(_vm.selectButtonLabel)),
            ]),
            _vm._v(" "),
            _c("i", { staticClass: "ico ico-chevron-down-thick" }),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isExpanded,
                expression: "isExpanded",
              },
            ],
            staticClass: "c-reservation-select__dropdown",
          },
          _vm._l(_vm.branches, function (branch) {
            return _c(
              "button",
              {
                key: `branch-${branch.id}`,
                staticClass: "c-reservation-select__item",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.onBranchClick(branch.id)
                  },
                },
              },
              [
                _c("strong", [_vm._v(_vm._s(branch.name))]),
                _vm._v(" "),
                _c("small", [_vm._v(_vm._s(branch.street))]),
              ]
            )
          }),
          0
        ),
      ]
    ),
    _vm._v(" "),
    !_vm.selectedBranch
      ? _c(
          "div",
          {
            staticClass:
              "c-reservation-select__info c-reservation-select__info--placeholder",
          },
          [
            _c("div", { staticClass: "sc-empty-bar sc-empty-bar--long" }),
            _vm._v(" "),
            _c("div", { staticClass: "sc-empty-bar" }),
            _vm._v(" "),
            _c("div", { staticClass: "sc-empty-bar" }),
          ]
        )
      : _c("div", { staticClass: "c-reservation-select__info" }, [
          _c("div", { staticClass: "sc-info-item" }, [
            _c("div", { staticClass: "sc-content" }, [
              _c("strong", [
                _vm._v(
                  _vm._s(_vm.selectedBranch.street) +
                    ", " +
                    _vm._s(_vm.selectedBranch.post_code) +
                    " " +
                    _vm._s(_vm.selectedBranch.city)
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _vm.selectedBranch.description
            ? _c("div", { staticClass: "sc-info-item" }, [
                _c("div", {
                  staticClass: "sc-content",
                  domProps: {
                    innerHTML: _vm._s(_vm.selectedBranch.description),
                  },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedBranch.lunch_break
            ? _c("div", { staticClass: "sc-info-item" }, [
                _c("div", {
                  staticClass: "sc-content",
                  domProps: {
                    innerHTML: _vm._s(_vm.selectedBranch.lunch_break),
                  },
                }),
              ])
            : _vm._e(),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }